import { Button } from '~components/Button';
import { ComponentLink } from '~components/ComponentLink';

import * as styles from './ComponentTextMedia.module.css';

import type { NodeRenderer } from '@contentful/rich-text-react-renderer';
import type { References } from './types';

export const renderEmbeddedBlockEntry =
  (references: References): NodeRenderer =>
  ({ data }) => {
    const entry = references.find(({ contentful_id }) => data.target.sys.id === contentful_id);
    switch (entry?.__typename) {
      case 'ContentfulComponentLink':
        return (
          <Button className={styles.link} element={<ComponentLink link={entry} />}>
            {entry.label}
          </Button>
        );
      default:
        return null;
    }
  };

export const renderEmbeddedInlineEntry =
  (references: References): NodeRenderer =>
  ({ data }) => {
    const entry = references.find(({ contentful_id }) => data.target.sys.id === contentful_id);
    switch (entry?.__typename) {
      case 'ContentfulComponentLink':
        return <ComponentLink link={entry}>{entry.label}</ComponentLink>;
      default:
        return null;
    }
  };
